import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { includes } from "lodash";
import AuthService from "src/_services/AuthService";

export const getCurrentUserProfile = createAsyncThunk(
    'profile/getCurrentUserProfile',
    async (_, { rejectWithValue }) => {
        try {
            const response = await AuthService.getCurrentUserProfile();
            return response.data.body;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

const slice = createSlice({
    name: "profile",
    initialState: {
        profile: null,
        loading: true,
        planId: null,
        updateProfilePending: false,
        errorStatus: null
    },
    reducers: {
        setUserProfile: (state, action) => {
            state.profile = action.payload;
        },
        updateLoading: (state, action) => {
            state.loading = action.payload
        },
        setPlan: (state, action) => {
            state.planId = action.payload
        },
        updateProfile: (state, action) => {
            state.profile = {
                ...state.profile,
                ...action.payload
            };
        }
    },
    extraReducers: {
        [getCurrentUserProfile.pending]: (state) => {
            // Only show full-page loading on initial load (when profile is null)
            // Subsequent refetches (e.g. from 703 error) should NOT unmount the app
            if (!state.profile) {
                state.loading = true
            }
            state.errorStatus = null
        },
        [getCurrentUserProfile.fulfilled]: (state, { payload }) => {
            let profile = { ...payload }
            state.profile = profile
            const { id, email, companyName, role, logo } = profile
            localStorage.setItem('current_user', JSON.stringify({ id, email, companyName, role, logo }))
            state.loading = false
        },
        [getCurrentUserProfile.rejected]: (state, action) => {
            if (includes([600, 402], action.payload?.status)) {
                state.errorStatus = action.payload?.status
            } else {
                state.errorStatus = "UNKNOWN"
            }
            // state.loading = false
        },
        // [updateProfile.pending]: (state) => {
        //     state.updateProfilePending = true
        // },
        // [updateProfile.fulfilled]: (state, { payload }) => {
        //     let profile = { ...state.profile, ...payload }
        //     state.profile = profile
        //     state.updateProfilePending = false
        // },
        // [updateProfile.rejected]: (state) => {
        //     state.updateProfilePending = false
        // },
    },
});


export const {
    setUserProfile,
    updateLoading,
    setPlan,
    updateProfile
} = slice.actions;



export default slice.reducer;
